import { render } from "./DeclarationList.vue?vue&type=template&id=430fc5d8"
import script from "./DeclarationList.vue?vue&type=script&lang=js"
export * from "./DeclarationList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\JOGA\\Desktop\\Projekty\\Trash3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__